import CrmEventsAPI from 'dashboard/api/crmEvents';

const state = {
  records: [],
  upcomingEvents: [],
  currentEvent: null,
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

const getters = {
  getEvents: $state => $state.records,
  getUpcomingEvents: $state => $state.upcomingEvents,
  getCurrentEvent: $state => $state.currentEvent,
  getUIFlags: $state => $state.uiFlags,
  getEventById: $state => id => $state.records.find(e => e.id === id),
};

const actions = {
  async fetch({ commit }, params = {}) {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const { data } = await CrmEventsAPI.get(params);
      commit('SET_EVENTS', data.payload);
    } catch (error) {
      throw error;
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  async show({ commit }, id) {
    try {
      const { data } = await CrmEventsAPI.show(id);
      commit('SET_CURRENT_EVENT', data.payload);
      return data.payload;
    } catch (error) {
      throw error;
    }
  },

  async create({ commit }, eventData) {
    commit('SET_UI_FLAG', { isCreating: true });
    try {
      const { data } = await CrmEventsAPI.create(eventData);
      commit('ADD_EVENT', data.payload);
      return data.payload;
    } catch (error) {
      throw error;
    } finally {
      commit('SET_UI_FLAG', { isCreating: false });
    }
  },

  async update({ commit }, { id, ...eventData }) {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      const { data } = await CrmEventsAPI.update(id, eventData);
      commit('UPDATE_EVENT', data.payload);
      return data.payload;
    } catch (error) {
      throw error;
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false });
    }
  },

  async delete({ commit }, id) {
    commit('SET_UI_FLAG', { isDeleting: true });
    try {
      await CrmEventsAPI.delete(id);
      commit('DELETE_EVENT', id);
    } catch (error) {
      throw error;
    } finally {
      commit('SET_UI_FLAG', { isDeleting: false });
    }
  },

  async fetchUpcoming({ commit }, params = {}) {
    try {
      const { data } = await CrmEventsAPI.upcoming(params);
      commit('SET_UPCOMING_EVENTS', data.payload);
    } catch (error) {
      throw error;
    }
  },

  async fetchByDateRange({ commit }, params = {}) {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const { data } = await CrmEventsAPI.get(params);
      commit('SET_EVENTS', data.payload);
    } catch (error) {
      throw error;
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },
};

const mutations = {
  SET_UI_FLAG($state, flag) {
    $state.uiFlags = { ...$state.uiFlags, ...flag };
  },
  SET_EVENTS($state, events) {
    $state.records = events;
  },
  SET_UPCOMING_EVENTS($state, events) {
    $state.upcomingEvents = events;
  },
  SET_CURRENT_EVENT($state, event) {
    $state.currentEvent = event;
  },
  ADD_EVENT($state, event) {
    $state.records.push(event);
  },
  UPDATE_EVENT($state, event) {
    const index = $state.records.findIndex(e => e.id === event.id);
    if (index !== -1) {
      $state.records.splice(index, 1, event);
    }
  },
  DELETE_EVENT($state, id) {
    $state.records = $state.records.filter(e => e.id !== id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
